import BitData from './BitData';

export default BitData;



// WEBPACK FOOTER //
// ./src/Components/Main/TestWorkflow/HoleGeometry/BitData/index.tsx